export const TEST_ID = 'serviceTargetFields';
